<template>
  <div ref="react_wrapper_placeholder" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import renderReactComponent from "./renderReactComponent";
import config from "../config";

export default defineComponent({
  name: "ReactWrapper",
  props: {
    domNode: HTMLElement,
    reactComponent: {
      type: Function,
      default: () => {},
    },
    props: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    props: function () {
      const ref = this.domNode || this.$refs.react_wrapper_placeholder;
      renderReactComponent(ref, this.reactComponent, this.getReactProps());
    },
  },
  mounted() {
    const ref = this.domNode || this.$refs.react_wrapper_placeholder;
    renderReactComponent(ref, this.reactComponent, this.getReactProps());
  },
  methods: {
    getReactProps: function () {
      return {
        ...this.props,
        $store: this.$store,
        $router: this.$router,
        $route: this.$route,
        $t: this.$t,
        messages: this.$i18n.messages,
        locale: this.$i18n.locale,
        clientVersion: config.get("version"),
        partnerProgramKnowledgeBaseURL: config.get("partnerProgramKnowledgeBaseURL"),
        partnerProgramBrandStoreURL: config.get("partnerProgramBrandStoreURL"),
        partnerProgramDashboardCTAURL: config.get("partnerProgramDashboardCTAURL"),
        partnerProgramNPSReportsCTAURL: config.get("partnerProgramNPSReportsCTAURL"),
        partnerProgramPartnerPointsCTAURL: config.get("partnerProgramPartnerPointsCTAURL"),
      };
    },
  },
});
</script>

<style lang="scss"></style>
